import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  useMediaQuery,
  useTheme
} from '@mui/material';

// import { useWindowSize } from '@uidotdev/usehooks';
import AddIcon from '@mui/icons-material/Add';

import { getBracketsByEventId } from '../../features/bracket/bracketSlice';

import GenerateBracketFromSections from './generateBracketFromSections';
import YellowButton from '../ui/buttons/yellowButton';

import { Roles, hasWorkspaceAccess } from '../../helpers/access';
import { useAuth } from '../../contexts/authContext';
import SingleBracket from '../ui/bracket';
import GenerateBracketFromPlayers from './generateBracketFromPlayers';
import { getEvent } from '../../features/event/eventSlice';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { store } from '../../config/firebase';
import { pickPrimaryBracket } from '../../helpers/bracketData';

const EMPTY_BRACKETS = [];

const Bracket = () => {
  const dispatch = useDispatch();
  const { eventId } = useParams();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { currentUserProfile, currentWorkspace } = useAuth();

  const rawBrackets = useSelector((state) => state.bracket.brackets);
  const brackets = Array.isArray(rawBrackets) ? rawBrackets : EMPTY_BRACKETS;
  const loading = useSelector((state) => state.bracket.loading);
  const event = useSelector((state) => state.event.event);

  const [openNewBracket, setOpenNewBracket] = useState(false);
  const [selectedBracket, setSelectedBracket] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    if (!eventId) return;

    if (!event) {
      dispatch(getEvent(eventId));
    }

    dispatch(getBracketsByEventId(eventId));
  }, [eventId, dispatch]);

  const bracketIds = useMemo(() => brackets.map((bracket) => bracket.id), [brackets]);

  useEffect(() => {
    if (!bracketIds || bracketIds.length === 0) {
      setSelectedBracket(null);
      return;
    }
    const collectionRef = collection(store, 'brackets');
    const q = query(collectionRef, where('__name__', 'in', bracketIds));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const bracketsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setSelectedBracket(pickPrimaryBracket(bracketsData));
    });
    return () => unsubscribe();
  }, [bracketIds]);

  const generateNewBracket = () => {
    setOpenNewBracket(true);
  };

  const closeNewBracket = () => {
    setOpenNewBracket(false);
  };

  // const handleOpenDelete = (bracket) => {
  //   setSelectedBracket(bracket);
  //   setOpenDelete(true);
  // };

  // const handleDeleteClose = () => {
  //   setOpenDelete(false);
  //   setSelectedBracket(null);
  // };

  // const handleDelete = () => {
  //   dispatch(removeBracket(selectedBracket.id))
  //     .unwrap()
  //     .then(() => {
  //       setOpenDelete(false);
  //       setSelectedBracket(null);
  //     });
  // };

  return !event && loading ? (
    <CircularProgress color="yellow" />
  ) : (
    event && (
      <Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
          gap={1}
          sx={{ mb: 2 }}>
          <Button variant="outlined" fullWidth={isMobile} onClick={() => navigate(`/events/${eventId}`)}>
            Back to Event
          </Button>
          {hasWorkspaceAccess(currentUserProfile, currentWorkspace, Roles.ADMIN) && brackets.length === 0 && (
            <YellowButton fullWidth={isMobile} onClick={generateNewBracket} startIcon={<AddIcon />}>
              Generate Bracket
            </YellowButton>
          )}
        </Box>

        {selectedBracket && <SingleBracket bracket={selectedBracket} event={event} />}

        <Dialog
          open={openNewBracket}
          onClose={closeNewBracket}
          fullWidth
          maxWidth="md"
          fullScreen={isMobile}
          PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden', backgroundImage: 'none' } }}
        >
          <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
            {event.hasBracketOnly && !event.hasSections && (
              <GenerateBracketFromPlayers
                event={event}
                onSuccess={closeNewBracket}
                onCancel={closeNewBracket}
              />
            )}

            {event.hasSections && (
              <GenerateBracketFromSections
                event={event}
                onSuccess={closeNewBracket}
                onCancel={closeNewBracket}
              />
            )}
          </DialogContent>
        </Dialog>

        {/* <Dialog
        open={openDelete}
        onClose={handleDeleteClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">{`Delete Bracket: ${selectedBracket?.name}`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            You are about to delete this bracket. Are you sure?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleDeleteClose}>
            Cancel
          </Button>
          <Button onClick={handleDelete} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog> */}
      </Box>
    )
  );
};

export default Bracket;
